<template>
  <v-container class="pa-3" fluid>
    <div class="text-h6 font-weight-bold">Mis Producciones a Beneficiar</div>
    <v-row dense>
      <!-- Botones para cada sección, incluido el de Pecuario -->
      <v-col cols="4">
        <v-btn class="btn" @click="mostrarCosechas">Agricola</v-btn>
      </v-col>
      <v-col cols="4">
        <v-btn class="btn" @click="mostrarAcuiculturas">Acuicola</v-btn>
      </v-col>
      <v-col cols="4">
        <v-btn class="btn" @click="mostrarAgroindustrias">Agroindustria</v-btn>
      </v-col>
      <v-col cols="4">
        <v-btn class="btn" @click="mostrarAgroturismos">Agroturismo</v-btn>
      </v-col>
      <v-col cols="4">
        <v-btn class="btn" @click="mostrarApiculturas">Apicola</v-btn>
      </v-col>
      <v-col cols="4">
        <v-btn class="btn" @click="mostrarAvicolas">Avicola</v-btn>
      </v-col>
      <v-col cols="4">
        <v-btn class="btn" @click="mostrarForestales">Forestal</v-btn>
      </v-col>
      <v-col cols="4">
        <v-btn class="btn" @click="mostrarPecuarios">Pecuario</v-btn>
      </v-col>
      <v-col cols="4">
        <v-btn class="btn" @click="mostrarPescas">Pesca</v-btn>
      </v-col>
    </v-row>

    <!-- Aqui se muestran los componentes -->
    <v-col cols="12" v-if="mostrarCosechasComponente">
      <Cosechas />
    </v-col>
    <v-col cols="12" v-if="mostrarAcuiculturasComponente">
      <Acuiculturas />
    </v-col>
    <v-col cols="12" v-if="mostrarAgroindustriasComponente">
      <Agroindustrias />
    </v-col>
    <v-col cols="12" v-if="mostrarPecuariosComponente">
      <Pecuarios />
    </v-col>
    <v-col cols="12" v-if="mostrarAgroturismosComponente">
  <Agroturismos />
</v-col>
<v-col cols="12" v-if="mostrarApiculturasComponente">
  <Apiculturas />
</v-col>
<v-col cols="12" v-if="mostrarAvicolasComponente">
  <Avicolas />
</v-col>
<v-col cols="12" v-if="mostrarForestalesComponente">
  <Forestales />
</v-col>
<v-col cols="12" v-if="mostrarPescasComponente">
  <Pescas />
</v-col>

  </v-container>
</template>

<script>
import Cosechas from './Cosechas.vue'
import Acuiculturas from './Acuiculturas.vue'
import Agroindustrias from './Agroindustrias.vue'
import Agroturismos from './Agroturismos.vue'
import Apiculturas from './Apiculturas.vue'
import Avicolas from './Avicolas.vue'
import Forestales from './Forestales.vue'
import Pecuarios from './Pecuarios.vue'
import Pescas from './Pescas.vue'

export default {
  components: {
    Cosechas,
  Acuiculturas,
  Agroindustrias,
  Pecuarios,
  Agroturismos,
  Apiculturas,
  Avicolas,
  Forestales,
  Pescas
  },
  data() {
    return {
        mostrarCosechasComponente: false,  
    mostrarAcuiculturasComponente: false,
    mostrarAgroindustriasComponente: false,
    mostrarPecuariosComponente: false,
    mostrarAgroturismosComponente: false,
    mostrarApiculturasComponente: false,
    mostrarAvicolasComponente: false,
    mostrarForestalesComponente: false,
    mostrarPescasComponente: false,
    }
  },
  methods: {
  mostrarCosechas() {
    this.resetComponentes()
    this.mostrarCosechasComponente = true
  },
  mostrarAcuiculturas() {
    this.resetComponentes()
    this.mostrarAcuiculturasComponente = true
  },
  mostrarAgroindustrias() {
    this.resetComponentes()
    this.mostrarAgroindustriasComponente = true
  },
  mostrarPecuarios() {
    this.resetComponentes()
    this.mostrarPecuariosComponente = true
  },
  mostrarAgroturismos() {
    this.resetComponentes()
    this.mostrarAgroturismosComponente = true
  },
  mostrarApiculturas() {
    this.resetComponentes()
    this.mostrarApiculturasComponente = true
  },
  mostrarAvicolas() {
    this.resetComponentes()
    this.mostrarAvicolasComponente = true
  },
  mostrarForestales() {
    this.resetComponentes()
    this.mostrarForestalesComponente = true
  },
  mostrarPescas() {
    this.resetComponentes()
    this.mostrarPescasComponente = true
  },
  resetComponentes() {
    this.mostrarCosechasComponente = false
    this.mostrarAcuiculturasComponente = false
    this.mostrarAgroindustriasComponente = false
    this.mostrarPecuariosComponente = false
    this.mostrarAgroturismosComponente = false
    this.mostrarApiculturasComponente = false
    this.mostrarAvicolasComponente = false
    this.mostrarForestalesComponente = false
    this.mostrarPescasComponente = false
  }
},
}
</script>

<style scoped>
.text-h5 {
  margin-bottom: 10px;
}

.btn {
  justify-content: flex-start !important;
  text-align: left;
  padding-left: 14px;
  width: 100%;
}
</style>
